var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 p-2 d-flex align-items-center"},[_vm._m(0),_c('div',{staticClass:"col-auto title-content py-1 text-center mx-3"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.title))])])]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 pt-0"},[_c('div',{staticClass:"title-divider-left"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 pt-0"},[_c('div',{staticClass:"title-divider-right w-100"})])
}]

export { render, staticRenderFns }